export const USER_DEFINED_LOCATION_ID = 'userDefined';

export default {
	USER_DEFINED_LOCATION_ID,
};